// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vA9z","textarea":"styles_textarea__24hYw"};